import type ShariffLinkGeneratorInterface from "@/ts/components/Shariff/Interfaces/ShariffLinkGeneratorInterface";

export default class PinterestShareLinkGenerator implements ShariffLinkGeneratorInterface {
    public generateLink(url: string): string {
        return "https://pinterest.com/pin/create/button"
            + "?url=" + encodeURIComponent(url);
    }

}
